import { Route, Routes } from "react-router";
import { ChapterNavItem } from "./ChapterNav";

export function ChapterRoutes(props:{chapterNavs:ChapterNavItem[]}){
    const routes:JSX.Element[] = []
    props.chapterNavs.forEach((chapterNav:ChapterNavItem, index:number)=>{
        if(index === 0){
            routes.push(<Route key={'default'} path={`*`} element={chapterNav.element}/>)
        }
        routes.push(<Route key={chapterNav.path} path={`/${chapterNav.path}`} element={chapterNav.element}/>)
        
    })
    return(
        <Routes>
            {routes}
        </Routes>
    )
}